// Special value string replace
export function specialreplace(str, special) {
  if (!str || !special) return str;

  const patterns = ['[X]', '[Y]', '[Z]', '[Q]'];
  const parts = special.toString().split('|');

  parts.forEach((part, i) => {
    const pattern = patterns[i];
    /* eslint-disable no-param-reassign */
    if (str.indexOf(pattern) > -1) {
      str = str.replace(pattern, part);
    }
  });
  return str;
}

export function specialremove(str, special) {
  if (!str || !special) return str;

  const patterns = ['[X]', '[Y]', '[Z]', '[Q]'];
  const parts = special.toString().split('|');

  parts.forEach((part, i) => {
    const pattern = patterns[i];
    /* eslint-disable no-param-reassign */
    if (str.indexOf(pattern) > -1) {
      str = str.replace(pattern, '');
    }
  });
  return str;
}

export function firstspecialreplace(str, special) {
  if (!str || !special) return str;

  const patterns = ['[X]', '[Y]', '[Z]', '[Q]'];
  const parts = special.toString().split('|');
  const firstSpecial = '[X]';

  parts.forEach((part, i) => {
    const pattern = patterns[i];
    /* eslint-disable no-param-reassign */
    if (str.indexOf(pattern) === -1) return;

    const replaceValue = pattern === firstSpecial ? part : '';

    str = str.replace(pattern, replaceValue);
  });
  return str;
}

export function standardTypeSpecialRemove(betName) {
  const placeholderPatterns = ['[X]', '[Y]', '[Z]', '[Q]'];
  let name = betName;

  placeholderPatterns.forEach((placeholder) => {
    name = name.replace(placeholder, '');
    return name;
  });

  return name;
}

export default {
  specialreplace,
  specialremove,
  firstspecialreplace,
  standardTypeSpecialRemove,
};
